import toast from 'react-hot-toast';

export const truncate = (input, length) => (input.length > length ? `${input.substring(0, length)}...` : input);

export const getRandomSmallString = () => (Math.random() + 1).toString(36).substring(7);

export const copyToClipboard = (string) => {
    navigator.clipboard.writeText(string);
    toast.success('Copied to clipboard');
};

export const removeTrailingZeros = (str) => {
    let newStr = str;
    while (newStr.at(-1) === '0') {
        newStr = newStr.slice(0, -1);
    }
    return newStr;
};
